import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './InfoStyle.css';
import ApiSender from '../common/ApiLogic';

function InfoPage() {

  const navigate = useNavigate();
  const location = useLocation();
  const apiSender = new ApiSender();
  const [msisdn, setMsisdn] = useState('');
  const [coreFlex, setCoreFlex] = useState(null);
  const [coreFlexActive, setCoreFlexActive] = useState(null);
  const [powerPlay, setPowerPlay] = useState(null);
  const [powerPlayActive, setPowerPlayActive] = useState(null);
  const [service, setService] = useState(null);

  const [showPopupUnsubProcess, setShowPopupUnsubProcess] = useState(false);
  const [showPopupChooseServiceToUnsub, setShowPopupChooseServiceToUnsub] = useState(true);
  const [showPopupUnsubServiceConfirm, setShowPopupUnsubServiceConfirm] = useState(false);
  const [showPopupUnsubResult, setShowPopupUnsubResult] = useState(false);
  const [unsubResult, setUnsubResult] = useState(null);

  useEffect(() => {
    const { msisdn, coreFlex, powerPlay } = location.state || {};

    if (msisdn) {
      setMsisdn(msisdn);
      handleMsisdnFocus();
    };

    let coreFlexService = coreFlex;
    let powerPlayService = powerPlay;
    updateServiceUI(coreFlexService, powerPlayService);
  }, [location.state]);

  useEffect(() => {
    if (showPopupUnsubProcess) {
      document.getElementById('service-name-coreflex-unsub-popup').classList.replace('enabled', 'disabled');
      document.getElementById('service-name-coreflex-unsub-popup').disabled = true;
      document.getElementById('service-name-powerplay-unsub-popup').classList.replace('enabled', 'disabled');
      document.getElementById('service-name-powerplay-unsub-popup').disabled = true;
      if (coreFlexActive) {
        document.getElementById('service-name-coreflex-unsub-popup').classList.replace('disabled', 'enabled');
        document.getElementById('service-name-coreflex-unsub-popup').disabled = false;
      }
      if (powerPlayActive) {
        document.getElementById('service-name-powerplay-unsub-popup').classList.replace('disabled', 'enabled');
        document.getElementById('service-name-powerplay-unsub-popup').disabled = false;
      }
    }
  }, [showPopupUnsubProcess]);

  const updateServiceUI = (coreFlex, powerPlay) => {

    const serviceElements = document.querySelectorAll(`[id^="service-name-"]`);
    const emptyElements = document.querySelectorAll(`[id^="empty-data-"]`);
    const infoElements = document.querySelectorAll(`[id^="info-data-"]`);
    serviceElements.forEach(el => el.classList.replace("active", "inactive"));
    emptyElements.forEach(el => el.classList.replace("invisible", "visible"));
    infoElements.forEach(el => el.classList.replace("visible", "invisible"));

    let serviceName;
    if (coreFlex) {
      serviceName = 'coreflex';
      setCoreFlex(coreFlex);
      setCoreFlexActive(coreFlex.active);
      const serviceElement = document.getElementById(`service-name-${serviceName}`);
      const emptyElement = document.getElementById(`empty-data-${serviceName}`);
      const infoElement = document.getElementById(`info-data-${serviceName}`);

      if (serviceElement && emptyElement && infoElement) {
        if (coreFlex.active) {
          serviceElement.classList.replace("inactive", "active");
        }
        else {
          serviceElement.classList.replace("active", "inactive");
        }
        if (!coreFlex) {
          emptyElement.classList.replace("invisible", "visible");
          infoElement.classList.replace("visible", "invisible");
        }
        else {
          emptyElement.classList.replace("visible", "invisible");
          infoElement.classList.replace("invisible", "visible");
        }
      }
    }
    if (powerPlay) {
      serviceName = 'powerplay';
      setPowerPlay(powerPlay);
      setPowerPlayActive(powerPlay.active);
      const serviceElement = document.getElementById(`service-name-${serviceName}`);
      const emptyElement = document.getElementById(`empty-data-${serviceName}`);
      const infoElement = document.getElementById(`info-data-${serviceName}`);

      if (serviceElement && emptyElement && infoElement) {
        if (powerPlay.active) {
          serviceElement.classList.replace("inactive", "active");
        }
        else {
          serviceElement.classList.replace("active", "inactive");
        }
        if (!powerPlay) {
          emptyElement.classList.replace("invisible", "visible");
          infoElement.classList.replace("visible", "invisible");
        }
        else {
          emptyElement.classList.replace("visible", "invisible");
          infoElement.classList.replace("invisible", "visible");
        }
      }
    }

    const unsubElement = document.getElementById('unsub-button');
    unsubElement.classList.replace('enabled', 'disabled');
    unsubElement.disabled = true;
    if ((coreFlex && coreFlex.active) || (powerPlay && powerPlay.active)) {
      unsubElement.classList.replace('disabled', 'enabled');
      unsubElement.disabled = false;
    }
  };

  const exitUnsubProcess = () => {
    setService(null);
    setShowPopupUnsubProcess(false);
    setShowPopupChooseServiceToUnsub(true);
    setShowPopupUnsubServiceConfirm(false);
    setShowPopupUnsubResult(false);
  }

  const choosingServiceToUnsub = (serviceName) => {
    setService(serviceName);
    setShowPopupUnsubProcess(true);
    setShowPopupChooseServiceToUnsub(false);
    setShowPopupUnsubServiceConfirm(true);
    setShowPopupUnsubResult(false);
  }

  const doUnsubscribeAction = async () => {
    try {
      let serviceValue = service === 'Coreflex' ? 'CF' : (service === 'Powerplay' ? 'PP' : '');
      const unsubResult = await apiSender.unsubscribe(msisdn, serviceValue);
      setShowPopupUnsubProcess(true);
      setShowPopupChooseServiceToUnsub(false);
      setShowPopupUnsubServiceConfirm(false);
      setShowPopupUnsubResult(true);
      if (!unsubResult.success) {
        const unsubResultCode = unsubResult.code;
        if (unsubResultCode === 4001) {
          localStorage.removeItem('token');
          localStorage.removeItem('expiration');
          navigate("/");
          window.location.reload();
          return;
        }
        setUnsubResult(unsubResult.message);
        return;
      }
      setUnsubResult(unsubResult.message);
      const searchResult = await apiSender.search(msisdn);
      if (!searchResult.success) {
        const searchResultCode = searchResult.code;
        if (searchResultCode === 4001) {
          localStorage.removeItem('token');
          localStorage.removeItem('expiration');
          navigate("/");
          window.location.reload();
          return;
        }
        return;
      }
      if (searchResult.empty) {
        return;
      }
      const coreFlex = searchResult.coreFlex;
      const powerPlay = searchResult.powerPlay;
      setCoreFlex(coreFlex);
      setPowerPlay(powerPlay);
      updateServiceUI(coreFlex, powerPlay);
    }
    catch (error) {
    }
  }

  const fetchData = async (serviceName) => {
    let serviceValue = serviceName === 'coreflex' ? 'CF' : (serviceName === 'powerplay' ? 'PP' : '');
    document.getElementById(`fetch-alert-${serviceName}`).style.opacity = 0;
    document.getElementById(`fetch-msg-result-${serviceName}`).textContent = '';
    const fetchDataResult = await apiSender.fetchData(msisdn, serviceValue);
    if (!fetchDataResult.success) {
      const fetchDataResultCode = fetchDataResult.code;
      if (fetchDataResultCode === 4001) {
        localStorage.removeItem('token');
        localStorage.removeItem('expiration');
        navigate("/");
        window.location.reload();
        return;
      }
      document.getElementById(`fetch-alert-${serviceName}`).style.opacity = 1;
      document.getElementById(`fetch-msg-result-${serviceName}`).textContent = fetchDataResult.message;
      return;
    }
    const list = fetchDataResult.data;
    const empty = fetchDataResult.empty;
    const data = { msisdn: msisdn, list: list, empty: empty };
    navigate("/details", { state: data });
  }

  const addFocus = (element) => {
    element.style.transform = 'translate(14px, -12px) scale(0.75)';
    element.style.backgroundColor = 'rgba(33, 28, 23, .8)';
    element.style.backdropFilter = 'blur(10px)';
    element.style.webkitBackdropFilter = 'blur(10px)';
    element.style.paddingLeft = '10px';
    element.style.paddingRight = '10px';
  }

  const removeFocus = (element) => {
    element.style.transform = '';
    element.style.backgroundColor = '';
    element.style.backdropFilter = '';
    element.style.webkitBackdropFilter = '';
    element.style.paddingLeft = '';
    element.style.paddingRight = '';
  }

  const revertColor = (element) => {
    element.style.color = '';
  }

  const revertBorderColor = (element) => {
    element.style.borderColor = '';
  }

  const handleMsisdnChange = (event) => {
    setMsisdn(event.target.value);
  };

  const handleMsisdnFocus = () => {
    document.getElementById("div-msisdn").style.borderColor = 'rgba(0, 0, 0, 1)';
    document.getElementById("msisdn-span").style.color = 'rgb(0, 0, 0)';
    addFocus(document.getElementById("msisdn-span"));
    document.getElementById("msisdn-span").style.backgroundColor = 'rgba(255, 255, 255, 1)';
  }

  const handleMsisdnBlur = () => {
    if (msisdn.length !== 0) {
      addFocus(document.getElementById("msisdn-span"));
      document.getElementById("msisdn-span").style.backgroundColor = 'rgba(255, 255, 255, 1)';
      revertBorderColor(document.getElementById("div-msisdn"));
      revertColor(document.getElementById("msisdn-span"));
      return;
    }
    revertBorderColor(document.getElementById("div-msisdn"));
    revertColor(document.getElementById("msisdn-span"));
    removeFocus(document.getElementById("msisdn-span"));
  }

  const search = async () => {
    try {
      if (!isZain(msisdn)) {
        document.getElementById("search-alert").style.opacity = 1;
        document.getElementById("search-msg-result").textContent = 'Invalid Phone Number';
        return;
      }

      document.getElementById("search-alert").style.opacity = 0;
      document.getElementById("search-msg-result").textContent = '';
      const searchResult = await apiSender.search(msisdn);
      if (!searchResult.success) {
        const searchResultCode = searchResult.code;
        if (searchResultCode === 4001) {
          localStorage.removeItem('token');
          localStorage.removeItem('expiration');
          navigate("/");
          window.location.reload();
          return;
        }
        document.getElementById("search-alert").style.opacity = 1;
        document.getElementById("search-msg-result").textContent = searchResult.message;
        return;
      }
      if (searchResult.empty) {
        document.getElementById("search-alert").style.opacity = 1;
        document.getElementById("search-msg-result").textContent = "No data found";
        return;
      }
      const coreFlex = searchResult.coreFlex;
      const powerPlay = searchResult.powerPlay;
      setCoreFlex(coreFlex);
      setPowerPlay(powerPlay);
      updateServiceUI(coreFlex, powerPlay);
    }
    catch (error) {
    }
  }

  const isZain = (msisdn) => {
    if (msisdn !== null && msisdn !== undefined) {
      return (msisdn.length === 13 && (msisdn.startsWith('96478') || msisdn.startsWith('96479')))
        || (msisdn.length === 11 && (msisdn.startsWith('078') || msisdn.startsWith('079')))
        || (msisdn.length === 10 && (msisdn.startsWith('78') || msisdn.startsWith('79')));
    }
    return false;
  }

  // ---- display-only tidy: never changes a value or its meaning ----
  const showVal = (value) => {
    if (value === null || value === undefined || String(value).trim() === '') return '—';
    return String(value);
  };

  const showDate = (value) => {
    const s = showVal(value);
    return s === '—' ? s : s.replace('T', ' ');
  };

  const showAmount = (value) => {
    if (value === null || value === undefined || String(value).trim() === '') return '—';
    const numeric = Number(String(value).replace(/,/g, '').trim());
    return Number.isFinite(numeric) ? `${numeric.toLocaleString('en-US')} IQD` : String(value);
  };

  const showYesNo = (value) => {
    if (value === null || value === undefined || String(value).trim() === '') return '—';
    const s = String(value).trim().toLowerCase();
    if (['true', '1', 'yes', 'y'].includes(s)) return 'Yes';
    if (['false', '0', 'no', 'n'].includes(s)) return 'No';
    return String(value);
  };

  const serviceDetails = (svc) => (
    <>
      <div className="cc-group">
        <h4>Subscription</h4>
        <dl className="cc-kv"><dt>Subscription date</dt><dd>{showDate(svc.subscriptionDate)}</dd></dl>
        <dl className="cc-kv"><dt>Unsubscription date</dt><dd>{showDate(svc.unsubscriptionDate)}</dd></dl>
        <dl className="cc-kv"><dt>Subscription method</dt><dd className="plain">{showVal(svc.subscriptionMethod)}</dd></dl>
        <dl className="cc-kv"><dt>Header enrichment / PIN flow</dt><dd className="plain">{showVal(svc.webFlowMethod)}</dd></dl>
        <dl className="cc-kv"><dt>OTP</dt><dd>{showVal(svc.otp)}</dd></dl>
        <dl className="cc-kv"><dt>Landing page</dt><dd>{showVal(svc.landingPage)}</dd></dl>
        <dl className="cc-kv"><dt>Is free trial</dt><dd className="plain">{showYesNo(svc.free)}</dd></dl>
        <dl className="cc-kv"><dt>Free trial expiry</dt><dd>{showDate(svc.freeTrialExpiry)}</dd></dl>
      </div>
      <div className="cc-group">
        <h4>Billing</h4>
        <dl className="cc-kv"><dt>Total charged amount</dt><dd>{showAmount(svc.totalChargeAmount)}</dd></dl>
        <dl className="cc-kv"><dt>Amount refunded</dt><dd>{showAmount(svc.amountRefunded)}</dd></dl>
        <dl className="cc-kv"><dt>Last success renewal</dt><dd>{showDate(svc.lastSuccessRenewal)}</dd></dl>
      </div>
      <div className="cc-group">
        <h4>Technical</h4>
        <dl className="cc-kv"><dt>IP address</dt><dd>{showVal(svc.ipAddress)}</dd></dl>
        <dl className="cc-kv"><dt>User agent</dt><dd className="ua">{showVal(svc.userAgent)}</dd></dl>
      </div>
    </>
  );

  const services = [coreFlex, powerPlay].filter(Boolean);
  const activeCount = services.filter(s => s && s.active).length;

  return (
    <div className='info'>
      {showPopupUnsubProcess && (
        <div className='popup-container'>
          <div className='popup-overlay'>
            <button className='close-btn' type="button" aria-label="Close" onClick={() => exitUnsubProcess()}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" /></svg>
            </button>
            <div className='popup-content'>
              {showPopupChooseServiceToUnsub && (
                <div>
                  <p className="popup-title">Choose a service to unsubscribe</p>
                  <div className='popup-content-button'>
                    <button id='service-name-powerplay-unsub-popup' className='service-name inactive disabled' onClick={() => choosingServiceToUnsub("Powerplay")}>PowerPlay</button>
                    <button id='service-name-coreflex-unsub-popup' className='service-name inactive disabled' onClick={() => choosingServiceToUnsub("Coreflex")}>CoreFlex</button>
                  </div>
                </div>
              )}
              {showPopupUnsubServiceConfirm && (
                <div>
                  <p className="popup-title">Unsubscribe from {service}?</p>
                  <p className="popup-note">This stops billing and removes the customer&rsquo;s access to {service} immediately.</p>
                  <div className='popup-content-button'>
                    <button className='service-name inactive' onClick={() => doUnsubscribeAction()}>Yes, unsubscribe</button>
                    <button className='service-name active' onClick={() => exitUnsubProcess()}>Cancel</button>
                  </div>
                </div>
              )}
              {showPopupUnsubResult && (
                <div>
                  <p className="popup-title">{unsubResult}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <header className="cc-topbar">
        <div className="cc-brand">
          <svg className="cc-mark" viewBox="0 0 48 48" aria-hidden="true">
            <g fill="none" stroke="currentColor" strokeWidth="1.6">
              <circle cx="24" cy="24" r="3.4" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(45 24 24)" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(90 24 24)" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(135 24 24)" />
            </g>
          </svg>
          <div className="cc-lock">
            <b>AL&middot;HORIZON</b>
            <span>Customer Care</span>
          </div>
        </div>
        <div className="cc-partner">Operated for Zain Iraq</div>
      </header>

      <div className="cc-body">
        <div className="cc-rail">
          <div id='div-msisdn' className='cc-field div-msisdn'>
            <span id='msisdn-span'>Phone Number</span>
            <div className='cc-field-input msisdn-input'>
              <input type="text" value={msisdn} autoComplete="off" minLength={10} maxLength={13} placeholder=" " required onChange={handleMsisdnChange} onFocus={handleMsisdnFocus} onBlur={handleMsisdnBlur} />
            </div>
          </div>
          <button className="cc-btn cc-btn-primary" onClick={search}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></svg>
            Search
          </button>
        </div>

        <div id='search-alert' className='alert'>
          <div className='left-alert'>
            <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
          </div>
          <div className='right-alert'>
            <span id="search-msg-result" className='message'></span>
          </div>
        </div>

        <div className="cc-ident">
          {msisdn ? <span className="cc-ident-num">{msisdn}</span> : <span className="cc-ident-num cc-ident-empty">No number searched</span>}
          {services.length > 0 && (
            <>
              <span className="cc-ident-div" />
              <div className="cc-ident-meta">
                <b>{services.length} service{services.length === 1 ? '' : 's'}</b>
                <span>{activeCount} active</span>
              </div>
            </>
          )}
          <div className="cc-ident-spacer" />
          <div className="cc-ident-actions">
            <button id='unsub-button' className='cc-btn cc-btn-danger cc-btn-sm disabled' onClick={() => setShowPopupUnsubProcess(true)}>Unsubscribe</button>
          </div>
        </div>

        <div className="cc-grid">
          <section className="cc-svc">
            <div className="cc-svc-head">
              <span id='service-name-coreflex' className='service-name inactive'>CoreFlex</span>
              <span className="cc-price">240 IQD</span>
            </div>
            <div className="cc-svc-inner">
              <div id='empty-data-coreflex' className='empty-data visible'>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12" /><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" /></svg>
                <b>No data found</b>
                <span>No CoreFlex subscription record for this number.</span>
              </div>
              <div id='info-data-coreflex' className='info-data invisible'>
                {coreFlex ? serviceDetails(coreFlex) : null}
                <div className="cc-svc-foot">
                  <div id='fetch-alert-coreflex' className='alert'>
                    <div className='left-alert'>
                      <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                    </div>
                    <div className='right-alert'>
                      <span id="fetch-msg-result-coreflex" className='message'></span>
                    </div>
                  </div>
                  <button className="cc-btn-link" onClick={() => fetchData('coreflex')}>
                    Check full logs
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                  </button>
                </div>
              </div>
            </div>
          </section>

          <section className="cc-svc">
            <div className="cc-svc-head">
              <span id='service-name-powerplay' className='service-name inactive'>PowerPlay</span>
              <span className="cc-price">240 IQD</span>
            </div>
            <div className="cc-svc-inner">
              <div id='empty-data-powerplay' className='empty-data visible'>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12" /><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" /></svg>
                <b>No data found</b>
                <span>No PowerPlay subscription record for this number.</span>
              </div>
              <div id='info-data-powerplay' className='info-data invisible'>
                {powerPlay ? serviceDetails(powerPlay) : null}
                <div className="cc-svc-foot">
                  <div id='fetch-alert-powerplay' className='alert'>
                    <div className='left-alert'>
                      <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24"><path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                    </div>
                    <div className='right-alert'>
                      <span id="fetch-msg-result-powerplay" className='message'></span>
                    </div>
                  </div>
                  <button className="cc-btn-link" onClick={() => fetchData('powerplay')}>
                    Check full logs
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );

}
export default InfoPage;
